<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="callout callout-warning">
      <div>
        <small>
          房间号前颜色为房间状态：1、绿色为全部已打卡；2、黄色为部分未打卡；3、红色为全部未打卡。
          <b class="color-danger">（ 实到人数 / 总人数 ）</b>
        </small>
      </div>
    </div>

    <el-card class="box-card" v-for="floor in itemData.floors" :key="floor.floorId">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont">
          <span class="spIcon"></span>
          楼层：{{ floor.floor }}
          <span v-if="floor.total > 0">
            <span class="spFloorEnable">
              打卡状态：
              <span class="color-success" v-if="floor.actual == floor.should || floor.actual + floor.leave == floor.total">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#fax-circle"></use>
                </svg>
                全部已打卡
              </span>
              <span class="color-warning" v-else-if="floor.actual > 0 && floor.actual">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#fax-circle"></use>
                </svg>
                部分未打卡
              </span>
              <span class="color-danger" v-else-if="floor.actual == 0">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#fax-circle"></use>
                </svg>
                全部未打卡
              </span>
            </span>
            <span class="spFloorEnable color-primary">总人数：{{ floor.total }}</span>
            <span class="spFloorEnable color-primary">应到人数：{{ floor.should }}</span>
            <span class="spFloorEnable color-primary">实到人数：{{ floor.actual }}</span>
            <span class="spFloorEnable color-primary">请假人数：{{ floor.leave }}</span>
          </span>
        </h3>
      </div>
      <div class="card-body" v-if="!regNullArray(floor.rooms)">
        <el-row :gutter="24">
          <el-col :span="4" v-for="room in onGetRoomData(floor.rooms)" :key="room.roomId">
            <el-tooltip class="TooltipItem" effect="dark" content="点击查看详情" placement="top">
              <div class="info-box" @click="onDialogRoom(room)">
                <div v-if="room.total > 0">
                  <span class="info-box-icon bg-success" v-if="room.actual == room.should || room.actual + room.leave == room.total">
                    {{ room.actual + room.leave }} / {{ room.total }}
                  </span>
                  <span class="info-box-icon bg-warning" v-else-if="room.actual > 0 && room.actual < room.should">{{ room.actual + room.leave }} / {{ room.total }}</span>
                  <span class="info-box-icon bg-danger" v-else-if="room.actual == 0">{{ room.actual + room.leave }} / {{ room.total }}</span>
                </div>
                <div v-else>
                  <span class="info-box-icon bg-info">空</span>
                </div>
                <div class="info-box-content">
                  <span class="info-box-text">{{ room.text }}</span>
                </div>
              </div>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <div class="card-body" v-else>
        <el-empty :image-size="100" description="暂无数据" name="3"></el-empty>
      </div>
    </el-card>

    <div class="row">
      <div class="col-12">
        <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="isShowRoom" width="65%" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="dialogBody" v-if="!regNullArray(bedData)">
        <el-row :gutter="20">
          <el-col :md="24" :lg="12" v-for="(item, index) in bedData" :key="item.bedId + '-' + index">
            <div class="itemBox">
              <!-- 头像 -->
              <div class="divAvatar">
                <el-image :src="onGetAvatar(item.photo)" class="elImage">
                  <div slot="error" class="imageSlot VerticalMid">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-user-alt"></use>
                    </svg>
                  </div>
                </el-image>
              </div>
              <!-- 信息 -->
              <div class="divInfo" v-if="!regNull(item.studentId)">
                <div class="divFonts">床位：{{ item.bed }}</div>
                <div class="divFonts">学号：{{ item.studentNo }}</div>
                <div class="divFonts">姓名：{{ item.studentName }}</div>
                <div class="divFonts">班级：{{ item.class }}</div>
                <div class="divFonts">班主任：{{ item.adviser }}</div>
                <div class="divFonts">班主任电话：{{ item.mobile }}</div>
                <div class="divFonts">
                  状态：
                  <b class="color-success" v-if="!regNull(item.attendDate) && regNull(item.leaveId)">已打卡</b>
                  <b class="color-danger" v-else-if="regNull(item.attendDate) && regNull(item.leaveId)">未打卡</b>
                  <b class="color-warning" v-else-if="!regNull(item.leaveId)">已请假</b>
                </div>

                <div class="btnCheckIn" v-if="regNull(item.attendDate) && regNull(item.leaveId)">
                  <el-button size="mini" type="primary" @click="onSign(item.memberId)">打卡</el-button>
                </div>
              </div>
              <div class="divInfo" v-else>
                <div class="nullBed VerticalMid">
                  床位：{{ item.bed }}
                  <br />
                  空
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card-body" v-else>
        <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/Admin.css';
export default {
  components: {},
  data() {
    return {
      fullscreenLoading: false,
      itemData: [],
      buildingId: null,
      attendanceId: null,

      dialogTitle: '详情',
      isShowRoom: false,
      dialogVisibleRQcode: false,

      bedData: [] // 房间信息
    };
  },
  methods: {
    // 手动考勤
    onSign(_dataID) {
      let that = this;
      that.fullscreenLoading = true;
      ajaxPost(that, '/api/attendance/sign', [_dataID], function (r) {
        that.fullscreenLoading = false;
        that.isLoading = false;
        that.isShowRoom = false;
        onGetData(that);
      });
    },
    /**
     * @description 对房间号排序
     * @param {@} objData
     */
    onGetRoomData(objData) {
      let that = this;
      if (!regNullArray(objData)) {
        return objData.sort(function (a, b) {
          return setInt(a.name) - setInt(b.name);
        });
      }
    },
    /**
     * @description 头像
     */
    onGetAvatar(objItem) {
      let that = this;
      return that.onImgSpliceUrlNoV(objItem);
    },
    // 返回
    onBack() {
      let that = this;
      back(that);
    },
    /**
     * @description 打开房间事件
     */
    onDialogRoom(objItem) {
      let that = this;
      that.bedData = [];
      if (!regNull(objItem)) {
        that.dialogTitle = '寝室房间：' + objItem.text;
        let data = {
          attendanceId: that.attendanceId,
          roomId: objItem.id
        };
        that.fullscreenLoading = true;
        ajaxGet(that, '/api/attendance/roomdetails', data, function (resData) {
          that.bedData = resData;
          that.fullscreenLoading = false;
          that.isShowRoom = true;
        });
      }
    }
  },
  created() {
    let that = this;
    that.buildingId = that.$route.params.Id;
    that.name = that.$route.query.text;
    that.attendanceId = that.$route.query.attendanceId;
    onGetData(that);
  }
};

// 加载页面数据
function onGetData(that) {
  let data = {
    attendanceId: that.attendanceId,
    buildingId: that.buildingId
  };
  that.fullscreenLoading = true;
  ajaxGet(that, '/api/attendance/statisbyfloor', data, function (resFloorData) {
    that.itemData.floors = resFloorData;
    that.fullscreenLoading = false;
  });
}
</script>

<style scoped="scoped" lang="less">
.dialogBody {
  .itemBox {
    display: flex;
    margin: 15px;

    .divAvatar {
      width: 150px;
      height: 209px;
      border: 1px solid #e4e7ed;
      border-radius: 5px;
      overflow: hidden;

      .elImage {
        width: 150px;
        height: 209px;

        .imageSlot {
          width: 150px !important;
          height: 209px !important;
        }
      }
    }

    .divInfo {
      margin-left: 15px;
      position: relative;

      .divFonts {
        font-size: 16px;
        padding-top: 5px;
      }

      .btnCheckIn {
        position: absolute;
        bottom: 3px;
        right: -30px;
      }

      .nullBed {
        height: 200px;
        width: 200px;
        font-weight: bolder;
        font-size: 32px;
        color: #c0c4cc;
        text-align: center;
      }
    }
  }
}

.TooltipItem {
  cursor: pointer;
}

.spFloorEnable {
  font-size: 14px;
  padding-left: 20px;
}

label {
  margin-bottom: 0;
}

.info-box {
  min-height: 40px;
  position: relative;
}

.info-box .info-box-icon {
  font-family: 'OswaldLight';
  width: 60px;
  font-size: 24px;
  text-align: center;
}

.info-box .info-box-text {
  font-size: 22px;
}
</style>

<style lang="less">
.elImage {
  .imageSlot {
    width: 150px;
    height: 209px;
    font-size: 72px;
    color: #c0c4cc;
  }
}
</style>
